<style scoped>
    @import url("../../../styles/smartControl/handleAgend.scss");
</style>

<template>
    <div class="box_handleAgend">

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!-- DIALOG MSG FROM CHILD -->
        <v-dialog v-model="flagDialogMsg" max-width="250px">
            <div class="" v-if="flagDialogMsg">
                <!-- O componente form -->
                <DialogMsg v-if="flagDialogMsg" :msgFromFather="msgToDialog" 
                @fromDialogMsg="desableDialogMsg($event)"
                />
            </div>
        </v-dialog>

        <v-dialog v-model="flagDialog" max-width="250px">
            <div class="" v-if="flagDialog">
                <!-- O componente form -->
                <DialogExec v-if="flagDialog" :liDatas2conv2Date="liDatas2conv2Date" 
                @fromDialog="desableDialog($event)" 
                />
            </div>
        </v-dialog>

        <div v-if="!flagLoading && !flagZero" class="painelLiEl mb-4">

            <!-- btn controle edit -->
            <div class="elBtnControl mt-4 mb-4" v-if="flagEditAgend">

                <v-btn @click="openAgend()"
                :style="{'background':'#DCDCDC'}"
                block
                >
                    {{ textBtnAgendOpen }}
                </v-btn>

                <div class="elAgend mt-4" v-if="flagFormAgend">
                    <FormAgend :key="countChangeChild" 
                    :elForm="elForm" :dateToday="dateToday" 
                    :sysSelected="sysSelected" :emailCliente="emailCliente"

                    @fromUp="handleExibByChild($event)"
                    />
                </div>
                
            </div>

        </div>

        <!--<div v-if="liElExec.length==0 && !flagLoading && !flagZero">
            <span>Nenhum agendamento para esse dia.</span>
        </div>-->

        <div class="lineBtns" v-if="!flagLoading && flagZero">
            <span>Sem dados referente a um controlador</span>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
//import { convHhmmFromUtc } from "./timeUtils.js"; // função auxiliar local
import { convHhmmFromUtc } from "../auxSC/handleTimeConv.js"; // 02/05/2026

import DialogMsg from './DialogMsg.vue'
import DialogExec from './DialogExec.vue'
import FormAgend from './FormAgend.vue'

export default {

    components:{ DialogMsg, DialogExec, FormAgend },

    props:['execSys', 'emailCliente'],

    data() {
        return {

            // dialog msg
            flagDialogMsg:false, // habilitado pelo filho apos update. Desabilitado pelo dialog.
            msgToDialog:'',

            //
            flagLoading:true,
            flagZero:false,

            // -- dialog (seleção data bind v-model)
            flagDialog:false,
            liDatas2conv2Date:[], // -- lista de datas (dias) disponíveis para exib.

            // -- sistema do cliente rcv via props.
            sysSelected:'',

            //
            dateToday:'',
            liGeralTable:[], // -- lista com um dia em cada posição. 
            liElExec:[], // -- dia mais recente da lista geral de execução.

            //
            timeoutDoDia:0, // registra o tempo de timeout para dia selecionado para exibição.

            //
            step: 0, // controla o item atual do stepper
            flagFormAgend:false,
            //flagBtnAgend:true,
            elForm:{},
            countChangeChild:0, // controla a mudança de estado do componente form.
            flagEditAgend:true, // controla o dia: se não é hoje, não há edição.

            //
            textBtnAgendOpen:'+ Novo agendamento',
        }
    },

    methods:{

        //nextStep(step) { this.step = Math.max(0, step) }, // Math.max(0, step - 1)
        //previousStep(step) { this.step = Math.min(this.liElExec.length - 1, step + 1) },

        desableDialogMsg() { this.flagDialogMsg = false },

        handleExibByChild(msgFromChild) {
            // UPDATE local.
            
            // -- msg de confirmação ou erro, após tentativa de update.
            this.flagDialogMsg = true
            this.msgToDialog = msgFromChild

            // exibir dialog de confirmação antes do jump
            setTimeout(() => {
                // jump to exec page
                this.$router.push(`/smartcontrol/execia`);
            },1000)

            //console.log('from child form timeline: ',elFromChild)
            //this.callInit() // -- reset grafico e editor.
            //this.openAgend() // -- abrir editor no modo novo agend.
        },

        openAgend() { 
            
            const agora = new Date();
            const date = agora.toLocaleDateString('pt-PT');
            this.dateToday = date; // --> props para o filho.
            
            // -- hora atual + 12min ==> 2min de preenchimento com margem 10min de tolerância para o input.
            agora.setMinutes(agora.getMinutes() + 12);
            // formata só HH:MM
            let horaMinuto = agora.toLocaleTimeString("pt-PT", {hour: "2-digit", minute: "2-digit"});
            
            // -- converter horário utc para horário local.
            //let ref_hhmm_local = "Europe/Lisbon" // prox versao, buscar info pre def pelo storage
            //horaMinuto = this.convHhmmFromUtc(horaMinuto, ref_hhmm_local)

            // -- abrir formulario vazio. Já com prox horario disponivel?
            let elAgend = {
                
                'step':-1, // flag que indica ser um novo agendamento

                "atuante":"", // Bomba Irrigação
                "tipo":"", // direto ou temporizado
                "titulo_atuador":"", // Irrigação, Ventilação, Iluminação

                "start_hr_utc":"",
                "end_hr_utc":"",

                "flag":"", // string ON ou OFF, se for um comando do tipo direto
                "data":date,
                "hr_utc":horaMinuto, // <-- horario atual + 10min
                "id_job":"", // <-- montado na verificação de disponibilidade no filho
                "last_update_by_uplink":"",
                "op":"",
                "pino_atuador":"",
                "command_hex":"",
                "status":"Pendente",
                "timeout_tempo_hr":1, // valor minimo | inteiro (!) | no front é string "00:00:01"
            }
            //this.flagBtnAgend = false // desabilitar btn
            this.elForm = elAgend
            this.flagFormAgend = true // habilitar form vazio

            this.textBtnAgendOpen = 'Reset preenchimento'

            this.countChangeChild++
        },

        jumpToStep(step) { this.step = step },

        onEditar(step, el) {
            // -- chamada de edição: 
            const agora = new Date();
            const date = agora.toLocaleDateString('pt-PT');

            this.elForm = el
            this.elForm.data = date // criar key data de hoje dentro do el edit
            this.elForm.step = step // criar key step (esperada no server para quando é edição).

            this.flagFormAgend = true // habilitar form com o elemento da do step atual
            //this.flagBtnAgend = true // habilitar btn, para caso queira add novo agendamento

            this.countChangeChild++

            //el_agend_item junto com cliente e sistema
            // /verifagend
        },

        segundosParaHHMMSS(totalSegundos) {

            let horas = Math.floor(totalSegundos / 3600);
            let minutos = Math.floor((totalSegundos % 3600) / 60);
            let segundos = totalSegundos % 60;

            const pad = (num) => String(num).padStart(2, '0');

            return `${pad(horas)}:${pad(minutos)}:${pad(segundos)}`;
        },
        
        changeDate() { this.flagDialog = true }, // -- abrir dialog calender

        changeDateToday() { 

            this.callInit() // reset direto 02/05/2026
            this.flagEditAgend = true // edição ou adição permitida.

            /*
            const agora = new Date();
            const hoje = agora.toLocaleDateString('pt-PT'); // para v2 -> dinamizar com config horario sistema
            
            // -- nao permitir chamar hoje repetidamente.
            if (this.dateToday != hoje) { // -- se já for hoje, passar.

                // -- a lista pode ser vazia sem problemas.

                this.dateToday = this.liGeralTable[0]['data']
                let liElExec_init = this.liGeralTable[0]['li_fila_utc']  // -- hoje == primeiro elemento da lista.
                let strFlag = this.ajustarExib(liElExec_init, 'local')
                if (strFlag != 'ok') { console.log('[ExecExibTable] FAILED') }
                //this.exibKey += 1 // -- forçar update componente

                this.flagEditAgend = true // edição ou adição permitida.
                
                //console.log('changeDateToday() | end')
            }
            */
        },

        desableDialog(fromDialog) {
            
            this.flagLoading = true
            this.flagDialog = false // -- desabilitar dialog calendar

            let c=0
            while (c < this.liGeralTable.length) {
                
                if (fromDialog == this.liGeralTable[c].data) { // -- match dt str
                    this.dateToday = fromDialog
                    //console.log('desableDialog() date from dialog: ',fromDialog)
                    let liElExec_init = this.liGeralTable[c]['li_fila_utc'] // -- elemento selecionado via evento calendar.
                    let strFlag = this.ajustarExib(liElExec_init)
                    //this.exibKey += 1 // -- forçar update componente
                    if (strFlag != 'ok') { console.log('[ExecExibTable] FAILED') } 
                    else { this.flagLoading = false }

                    // -- se a data nao for a de hoje, desabilitar edição geral.
                    const agora = new Date();
                    const hoje = agora.toLocaleDateString('pt-PT'); // para v2 -> dinamizar com config horario sistema
                    if (this.dateToday != hoje) { 

                        this.step = 0 // reset step quando mudar o dia
                        this.flagEditAgend = false // -- proibido editar a partir de dias anteriores.
                    }
                    else {
                        // se for hoje chamar rotina init (selecionar agend mais prox para exibir)
                        //this.ajustarExib(this.liElExec)
                        this.flagEditAgend = true // edição ou adição permitida
                    }
                    
                    return
                }
                c++
            }
        },

        middleFunc(segundos) { return this.segundosParaHHMMSS(segundos) },

        convIso2dataStr(iso2conv) {
            //const iso2conv = "2026-05-02T04:23:00.824+00:00";
            const d = new Date(iso2conv);
            const data = d.toLocaleDateString("pt-PT", { timeZone: "UTC" }); // <-- garantia de que é utc
            return data
        },

        cutIsodtFromIdJob(idJobStr) {

            // retorna dt string no formato dd/mm/aaaa (formato "pt-PT")

            //const idJobStr = "upinc_upinc1_light_Ventilação_outro_0804_4:25_reagend_2026-05-02T04:23:00.824+00:00_3_direto";
            const match = idJobStr.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}\+\d{2}:\d{2}/);
            const iso = match ? match[0] : null;

            if (iso) {
                return this.convIso2dataStr(iso);
            }

            // fallback: hoje em UTC | "pt-PT" é apenas o formato da string, não altera o fuso
            return new Date().toLocaleDateString("pt-PT", { timeZone: "UTC" });
        },

        ajustarExib(liElExec_init) {

            // -- loop ajustar exibição dos itens do dia selecionado (inicia com o mais recente).
            let self = this
            self.liElExec = [] // reset
            let flagStepInitSelected = true
            let flagGetTimeout = true
            let c=0
            while (c < liElExec_init.length) {

                // -- converter horário utc para horário local.
                //let ref_hhmm_local = "Europe/Lisbon" // prox versao, buscar info pre def pelo storage
                //liElExec_init[c]['hr_utc'] = convHhmmFromUtc(liElExec_init[c]['hr_utc'], ref_hhmm_local)
                const tzName = this.$store.state.fusoHorarioSC // esperado --> "Europe/Lisbon"
                const dataStr = this.cutIsodtFromIdJob(liElExec_init[c]['id_job'])
                liElExec_init[c]['hr_utc'] = convHhmmFromUtc(liElExec_init[c]['hr_utc'], tzName, dataStr)

                if (liElExec_init[c]['command_hex'].slice(0, 2) != '07') {

                    if (liElExec_init[c]['status'] == 'init') { 
                        liElExec_init[c]['status'] = 'Agendado'
                        if ( flagStepInitSelected ) { self.step = c; flagStepInitSelected=false } // o prox agend inicia o front
                    }
                    if (liElExec_init[c]['status'] == 'ok') { liElExec_init[c]['status'] = 'Executado'}
                    if (liElExec_init[c]['status'] == 'start') { liElExec_init[c]['status'] = 'Executando'}

                    //if (liElExec_init[c]['command_hex'].slice(0, 2) == '08') {liElExec_init[c]['flag'] = 'ON'}
                    //if (liElExec_init[c]['command_hex'].slice(0, 2) == '09') {liElExec_init[c]['flag'] = 'OFF'}

                    if (liElExec_init[c]['command_hex'].slice(0, 2) == '08') {liElExec_init[c]['flag'] = 'Ligar'}
                    if (liElExec_init[c]['command_hex'].slice(0, 2) == '09') {liElExec_init[c]['flag'] = 'Desligar'}

                    if (liElExec_init[c]['command_hex'].slice(0, 2) == '06') {
                        liElExec_init[c]['flag'] = 'ON'
                        liElExec_init[c]['op'] = 'Timeout' // add nova key ao dict
                        if (flagGetTimeout) {
                            self.timeoutDoDia = self.middleFunc(parseInt(liElExec_init[c-1]['irrig_tempo_segundos']))
                            //flagGetTimeout = false // obter tempo de timeout apenas 1 vez.
                        }
                        liElExec_init[c]['timeout_tempo_hr'] = self.timeoutDoDia // todos os timeout parciais tem o mesmo tempo.
                    } else {
                        liElExec_init[c]['op'] = 'Direto'
                    }

                    if (liElExec_init[c]['atuante'] == 'irrig') { liElExec_init[c]['atuante'] = 'Bomba Irrigação'}
                    if (liElExec_init[c]['atuante'] == 'luz') { liElExec_init[c]['atuante'] = 'Iluminação'}
                    if (liElExec_init[c]['atuante'] == 'vent') { liElExec_init[c]['atuante'] = 'Ventilação'}

                    self.liElExec.push(liElExec_init[c]) // não inputar o disparo de ajuste.
                }
                c++
            }
            return 'ok'
        },

        isAfterLimit(dateStr) {

            // RETORNA BOOL
            
            try {

                // Data limite: 13/08/2025 (no formato MM/DD/YYYY no JS puro)
                const limite = new Date(2025, 7, 13); // mês 7 = agosto (0 indexado)

                if (!dateStr || typeof dateStr !== 'string') return false;

                // Converter entrada "DD/MM/YYYY"
                const [dia, mes, ano] = dateStr.split('/').map(Number);
                const dataInput = new Date(ano, mes - 1, dia);

                return dataInput.getTime() > limite.getTime(); // se data depois de 14/09/24 => true
            }
            catch (erro) {
                console.error("Erro:", erro);
                return false
            }
        },

        callInit() {

            this.elForm.step = -1 // init na modalidade de criação de novo agendamento.
            // <-- o elForm é o obj local snap. (this.step controla a exibição)

            this.flagLoading = true

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':this.emailCliente, 'sistema':this.sysSelected}

            let url = self.$store.state.pathAxiosBASE + '/getagend'

            axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result)
                
                self.liGeralTable = res.data.result

                if (self.liGeralTable.length == 0) { 
                    //self.flagZero = true; 
                    self.flagLoading = false // -- encerrar loading
                    return; 
                    // esse return habilita o input de novo agendamento na lista vazia? 02/11/25
                }
                self.flagZero = false // reset flag

                self.dateToday = self.liGeralTable[0]['data']
                let liElExec_init = self.liGeralTable[0]['li_fila_utc'] // -- elemento de hoje. (1o da lista)

                // -- loop obter datas disponíveis.
                let i=0
                while (i < self.liGeralTable.length) { // -- colocar hoje. 30/05/2025
                    
                    let flagBoolDateAfter = self.isAfterLimit(self.liGeralTable[i].data)

                    if (flagBoolDateAfter) { // apenas datas depois de 14/08/2025

                        self.liDatas2conv2Date.push(self.liGeralTable[i].data) // -- dt string
                    }
                    
                    i++
                }

                let strFlag = self.ajustarExib(liElExec_init) // -- ajustar a lista do dia para exibição.

                if (strFlag == 'ok') {

                    self.flagLoading = false // -- encerrar loading

                } else {

                    console.log('[TIMELINE] FAILED')
                }
            })
        },
    },

    created() {
        window.scrollTo(0,0)

        this.sysSelected = this.execSys
        //console.log('[ExecTable] execSys -> sys_selected: ',this.sysSelected)
        //console.log('[ExecTable] emailCliente: ',this.emailCliente)

        this.callInit()
    }
}
</script>